var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5927 24.8638C9.76373 25.0923 9.01987 25.4958 8.39502 26.0266H70.8369V14.699C70.8369 11.4789 67.7716 9.1432 64.667 9.99656L10.5927 24.8638Z",
    fill: "url(#paint0_linear_5160_13418)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7373 26.0263H70.8369V14.6987C70.8369 11.4786 67.7716 9.1423 64.667 9.99626L10.5933 24.8635C10.5849 24.8658 10.5766 24.8682 10.5683 24.8706C9.91368 25.0539 10.0577 26.0263 10.7373 26.0263Z",
    fill: "url(#paint1_linear_5160_13418)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3795 20.0067C64.3795 9.04385 54.4415 0.156738 42.1826 0.156738C29.9237 0.156738 19.9862 9.04385 19.9862 20.0067V24.6996C19.9862 35.6624 29.9237 44.5495 42.1826 44.5495C54.4415 44.5495 64.3795 35.6624 64.3795 24.6996C64.3795 24.6841 64.3795 20.0221 64.3795 20.0067Z",
    fill: "url(#paint2_linear_5160_13418)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4639 8.7475C56.4595 3.55829 49.7659 0.156738 42.1826 0.156738C34.5993 0.156738 27.9057 3.55829 23.9014 8.7475V35.9593C27.9057 41.1485 34.5993 44.5501 42.1826 44.5501C49.7659 44.5501 56.4595 41.1485 60.4639 35.9593V8.7475Z",
    fill: "url(#paint3_linear_5160_13418)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1637 40.7762C32.8211 43.1494 37.3183 44.5497 42.1825 44.5497C47.0462 44.5497 51.5439 43.1494 55.2014 40.7762V3.92924C51.5439 1.55661 47.0462 0.155762 42.1825 0.155762C37.3183 0.155762 32.8211 1.55602 29.1637 3.92924V40.7762Z",
    fill: "url(#paint4_linear_5160_13418)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1398 44.0347C38.7596 44.3715 40.4479 44.5495 42.1826 44.5495C43.9173 44.5495 45.6056 44.3715 47.2254 44.0347V0.671493C45.6056 0.334671 43.9173 0.156738 42.1826 0.156738C40.4479 0.156738 38.7596 0.334671 37.1398 0.671493V44.0347Z",
    fill: "#00C766"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3795 20.0067C64.3795 9.04385 54.4415 0.156738 42.1826 0.156738C29.9237 0.156738 19.9862 9.04385 19.9862 20.0067C19.9862 30.97 29.9237 39.8572 42.1826 39.8572C54.4415 39.8572 64.3795 30.97 64.3795 20.0067Z",
    fill: "url(#paint5_radial_5160_13418)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4612 20.0069C22.4612 29.7468 31.2906 37.6431 42.1825 37.6431C53.0739 37.6431 61.9033 29.7468 61.9033 20.0069C61.9033 10.2664 53.0739 2.37013 42.1825 2.37013C31.2906 2.37013 22.4612 10.2664 22.4612 20.0069Z",
    fill: "url(#paint6_radial_5160_13418)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.036 20.0063C60.036 11.1888 52.0427 4.04053 42.1826 4.04053C32.3225 4.04053 24.3292 11.1888 24.3292 20.0063C24.3292 28.8244 32.3225 35.9726 42.1826 35.9726C52.0427 35.9726 60.036 28.8244 60.036 20.0063Z",
    fill: "#FEE55A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8887 30.9032C60.8887 22.6885 61.7723 33.2325 57.0693 26.8433L43.698 20.9716C43.6312 20.9546 43.5628 20.9409 43.4932 20.9305C42.3783 20.7647 41.3398 21.5341 41.1735 22.6488L42.3567 20.8757L43.6977 20.9719C42.5815 20.8028 41.5367 21.5712 41.3668 22.6885C41.197 23.8059 41.9652 24.849 43.0826 25.0183L43.7694 25.2293C48.7774 27.0184 56.385 30.2208 60.8887 30.9032Z",
    fill: "url(#paint7_linear_5160_13418)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M42.1826 44.5496C47.2426 44.5496 51.9064 43.0345 55.64 40.4852L23.9019 8.74707C21.4329 11.9463 19.9862 15.8251 19.9862 20.0062V24.6991C19.9856 35.6619 29.9237 44.5496 42.1826 44.5496Z",
    fill: "url(#paint8_linear_5160_13418)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5902 31.7791V71.9842C76.5902 75.1614 74.0147 77.737 70.8375 77.737H12.1185C8.94128 77.737 6.36572 75.1614 6.36572 71.9842V30.4116C6.36572 28.6811 7.13696 27.0946 8.39261 26.0264H70.8375C74.0147 26.0264 76.5902 28.6019 76.5902 31.7791Z",
    fill: "url(#paint9_linear_5160_13418)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36511 31.5815H66.6183C69.167 31.5815 71.2332 33.4841 71.2332 35.8311V67.202C71.2332 69.5491 69.167 71.4522 66.6183 71.4522H6.36511V31.5815Z",
    fill: "url(#paint10_linear_5160_13418)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5897 71.9843V41.6156C76.3564 41.5287 76.1047 41.4805 75.841 41.4805H56.5374C55.3448 41.4805 54.3784 42.4469 54.3784 43.6395V53.7995C54.3784 54.5136 54.7265 55.145 55.2615 55.5383L75.3162 75.5924C76.1124 74.6057 76.5897 73.3513 76.5897 71.9843Z",
    fill: "url(#paint11_linear_5160_13418)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M75.841 55.9585H56.5374C55.3448 55.9585 54.3784 54.9921 54.3784 53.7995V43.6395C54.3784 42.4469 55.3448 41.4805 56.5374 41.4805H75.841C77.0336 41.4805 78 42.4469 78 43.6395V53.7995C78 54.9915 77.0336 55.9585 75.841 55.9585Z",
    fill: "url(#paint12_linear_5160_13418)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36511 59.0679V71.9844C6.36511 75.1616 8.94067 77.7371 12.1179 77.7371H70.8369C74.0141 77.7371 76.5896 75.1616 76.5896 71.9844V59.0679H6.36511Z",
    fill: "url(#paint13_linear_5160_13418)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2311 45.6871C64.4046 44.7742 63.2102 44.2012 61.882 44.2012C59.3867 44.2012 57.364 46.2239 57.364 48.7191C57.364 50.0474 57.9371 51.2417 58.8494 52.0683L62.7395 55.9584H75.503L65.2311 45.6871Z",
    fill: "url(#paint14_linear_5160_13418)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5567 25.289C60.5567 17.0743 62.9745 19.6431 58.2715 13.2538L44.9002 7.3822C44.8334 7.36518 44.765 7.35146 44.6954 7.34107C43.5806 7.17529 42.542 7.94462 42.3757 9.05936L42.0246 15.2615L43.3657 15.3577C42.2495 15.1886 41.2047 15.957 41.0348 17.0743C40.865 18.1917 41.6332 19.2348 42.7506 19.4041L43.4374 19.6151C48.4453 21.4042 56.053 24.6065 60.5567 25.289Z",
    fill: "url(#paint15_linear_5160_13418)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4005 48.7191C66.4005 51.2149 64.3778 53.2377 61.882 53.2377C59.3867 53.2377 57.364 51.2149 57.364 48.7191C57.364 46.2239 59.3867 44.2012 61.882 44.2012C64.3778 44.2012 66.4005 46.2239 66.4005 48.7191Z",
    fill: "url(#paint16_radial_5160_13418)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5160_13418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0273 22.465C44.0273 23.482 43.1561 24.375 42.1355 24.375C41.0403 24.375 40.2188 23.4822 40.2188 22.465C40.2188 21.4233 41.0403 20.5549 42.1355 20.5549C43.1561 20.5549 44.0273 21.4233 44.0273 22.465ZM43.5543 17.7521C43.5543 18.5211 42.7081 18.8436 42.1105 18.8436C41.3139 18.8436 40.6418 18.5211 40.6418 17.7521C40.6418 14.8003 40.2934 10.5585 40.2934 7.60679C40.2934 6.63942 41.0899 6.09375 42.1105 6.09375C43.0813 6.09375 43.9029 6.63942 43.9029 7.60679C43.9029 10.5585 43.5543 14.8003 43.5543 17.7521Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5160_13418",
    x: 34.2188,
    y: 2.09375,
    width: 11.8086,
    height: 26.2812,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5160_13418"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5160_13418",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5160_13418",
    x1: 39.616,
    y1: 13.563,
    x2: 39.616,
    y2: 27.7664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AB58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AB58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5160_13418",
    x1: 40.4913,
    y1: 17.0776,
    x2: 40.4913,
    y2: 38.6585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AB58",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81FFC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5160_13418",
    x1: -4.79545,
    y1: 8.76991,
    x2: 81.6096,
    y2: 8.76991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03FF84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2344,
    stopColor: "#03FF84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4454,
    stopColor: "#03FF84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6474,
    stopColor: "#00E676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8426,
    stopColor: "#02C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AB58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5160_13418",
    x1: 40.0698,
    y1: 18.2898,
    x2: 58.3141,
    y2: 53.3751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCA17A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#F69373",
    stopOpacity: 0.152941
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416,
    stopColor: "#EF816B",
    stopOpacity: 0.415686
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6926,
    stopColor: "#EA7666",
    stopOpacity: 0.694118
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97264"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5160_13418",
    x1: 41.4997,
    y1: 29.2796,
    x2: 39.3448,
    y2: 51.1362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B53759"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_5160_13418",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4071 7.8595) scale(43.2025 38.6361)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03FF84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2344,
    stopColor: "#03FF84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4454,
    stopColor: "#03FF84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6474,
    stopColor: "#00E676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8426,
    stopColor: "#02C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AB58"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_5160_13418",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.5369 30.7993) rotate(-180) scale(38.3842 34.3273)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03FF84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2344,
    stopColor: "#03FF84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4454,
    stopColor: "#03FF84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6474,
    stopColor: "#00E676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8426,
    stopColor: "#02C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AB58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5160_13418",
    x1: 57.7706,
    y1: 25.5969,
    x2: 15.901,
    y2: 23.0272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B395F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B395F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5160_13418",
    x1: 43.4336,
    y1: 42.0036,
    x2: 12.0126,
    y2: 10.5826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63FFB3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AB58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5160_13418",
    x1: 41.4782,
    y1: 37.9712,
    x2: 41.4782,
    y2: 83.2884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02F780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5160_13418",
    x1: 34.1522,
    y1: 31.5189,
    x2: 45.5508,
    y2: 89.5019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AB58",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E676"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5160_13418",
    x1: 68.2536,
    y1: 74.3565,
    x2: 44.0344,
    y2: 64.1349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B395F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B395F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5160_13418",
    x1: 65.6372,
    y1: 44.5585,
    x2: 68.4192,
    y2: 65.5304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AB58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5160_13418",
    x1: 41.4775,
    y1: 66.3441,
    x2: 41.4775,
    y2: 79.7721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AB58",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FFA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_5160_13418",
    x1: 68.6953,
    y1: 55.5324,
    x2: 57.0443,
    y2: 43.8815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B395F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B395F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5160_13418",
    x1: 57.4383,
    y1: 19.9829,
    x2: 15.5687,
    y2: 17.4133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B395F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B395F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_5160_13418",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.1137 45.9544) scale(8.79409 8.79422)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03FF84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2344,
    stopColor: "#03FF84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4454,
    stopColor: "#03FF84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6474,
    stopColor: "#00E676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8426,
    stopColor: "#02C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AB58"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletVerify);
export default __webpack_public_path__ + "static/media/wallet-verify.e32fb606c38dff41b91948540d503034.svg";
export { ForwardRef as ReactComponent };